@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_255_115_742)
internal val Res.string.pyramidsGizaPullQuote1Top: StringResource by lazy {
      StringResource("string:pyramidsGizaPullQuote1Top", "pyramidsGizaPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94102, 137),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38658, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43294, 77),
      ))
    }

@delegate:ResourceContentHash(-903_822_302)
internal val Res.string.pyramidsGizaPullQuote2: StringResource by lazy {
      StringResource("string:pyramidsGizaPullQuote2", "pyramidsGizaPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94349, 246),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38789, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43433, 122),
      ))
    }

@delegate:ResourceContentHash(-1_137_747_035)
internal val Res.string.pyramidsGizaPullQuote2Author: StringResource by lazy {
      StringResource("string:pyramidsGizaPullQuote2Author", "pyramidsGizaPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94240, 108),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38740, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43372, 60),
      ))
    }

@delegate:ResourceContentHash(-1_986_047_220)
internal val Res.string.pyramidsGizaRegionTitle: StringResource by lazy {
      StringResource("string:pyramidsGizaRegionTitle", "pyramidsGizaRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94596, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38904, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43556, 47),
      ))
    }

@delegate:ResourceContentHash(-1_202_641_719)
internal val Res.string.pyramidsGizaSubTitle: StringResource by lazy {
      StringResource("string:pyramidsGizaSubTitle", "pyramidsGizaSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94676, 88),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38952, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43604, 52),
      ))
    }

@delegate:ResourceContentHash(-317_214_176)
internal val Res.string.pyramidsGizaTitle: StringResource by lazy {
      StringResource("string:pyramidsGizaTitle", "pyramidsGizaTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94765, 85),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39001, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43657, 49),
      ))
    }

@delegate:ResourceContentHash(1_855_674_540)
internal val Res.string.pyramidsGizaVideoCaption: StringResource by lazy {
      StringResource("string:pyramidsGizaVideoCaption", "pyramidsGizaVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94851, 472),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39047, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43707, 212),
      ))
    }

@delegate:ResourceContentHash(1_741_347_971)
internal val Res.string.resultsPopupEnglishContent: StringResource by lazy {
      StringResource("string:resultsPopupEnglishContent", "resultsPopupEnglishContent", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 95324, 426),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39244, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43920, 178),
      ))
    }

@delegate:ResourceContentHash(-1_330_009_239)
internal val Res.string.resultsSemanticDismiss: StringResource by lazy {
      StringResource("string:resultsSemanticDismiss", "resultsSemanticDismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 95751, 90),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39383, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44099, 50),
      ))
    }

@delegate:ResourceContentHash(-1_569_192_263)
internal val Res.string.scrollingContentSemanticOpen: StringResource by lazy {
      StringResource("string:scrollingContentSemanticOpen", "scrollingContentSemanticOpen", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 95842, 136),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39430, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44150, 72),
      ))
    }

@delegate:ResourceContentHash(-222_842_058)
internal val Res.string.scrollingContentSemanticYoutube: StringResource by lazy {
      StringResource("string:scrollingContentSemanticYoutube", "scrollingContentSemanticYoutube", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 95979, 95),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39491, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44223, 63),
      ))
    }

@delegate:ResourceContentHash(131_198_026)
internal val Res.string.searchInputHintSearch: StringResource by lazy {
      StringResource("string:searchInputHintSearch", "searchInputHintSearch", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96075, 133),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39563, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44287, 69),
      ))
    }

@delegate:ResourceContentHash(-905_945_714)
internal val Res.string.searchInputSemanticClear: StringResource by lazy {
      StringResource("string:searchInputSemanticClear", "searchInputSemanticClear", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96209, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39601, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44357, 48),
      ))
    }

@delegate:ResourceContentHash(1_503_338_303)
internal val Res.string.searchInputTitleSuggestions: StringResource by lazy {
      StringResource("string:searchInputTitleSuggestions", "searchInputTitleSuggestions", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96286, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39650, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44406, 51),
      ))
    }

@delegate:ResourceContentHash(233_272_796)
internal val Res.string.semanticsNext: StringResource by lazy {
      StringResource("string:semanticsNext", "semanticsNext", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96342, 45),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39694, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44458, 33),
      ))
    }

@delegate:ResourceContentHash(-163_835_096)
internal val Res.string.semanticsPrevious: StringResource by lazy {
      StringResource("string:semanticsPrevious", "semanticsPrevious", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96388, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39744, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44492, 45),
      ))
    }

@delegate:ResourceContentHash(1_064_054_658)
internal val Res.string.tajMahal1631ce: StringResource by lazy {
      StringResource("string:tajMahal1631ce", "tajMahal1631ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96442, 290),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39798, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44538, 114),
      ))
    }

@delegate:ResourceContentHash(-956_211_811)
internal val Res.string.tajMahal1647ce: StringResource by lazy {
      StringResource("string:tajMahal1647ce", "tajMahal1647ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 96733, 330),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 39897, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44653, 138),
      ))
    }

@delegate:ResourceContentHash(-17_906_321)
internal val Res.string.tajMahal1658ce: StringResource by lazy {
      StringResource("string:tajMahal1658ce", "tajMahal1658ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 97064, 530),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40012, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44792, 250),
      ))
    }

@delegate:ResourceContentHash(494_482_091)
internal val Res.string.tajMahal1901ce: StringResource by lazy {
      StringResource("string:tajMahal1901ce", "tajMahal1901ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 97595, 566),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40223, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45043, 254),
      ))
    }

@delegate:ResourceContentHash(-598_264_559)
internal val Res.string.tajMahal1984ce: StringResource by lazy {
      StringResource("string:tajMahal1984ce", "tajMahal1984ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 98162, 586),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40430, 234),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45298, 218),
      ))
    }

@delegate:ResourceContentHash(-1_730_582_736)
internal val Res.string.tajMahal1998ce: StringResource by lazy {
      StringResource("string:tajMahal1998ce", "tajMahal1998ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 98749, 310),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40665, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45517, 130),
      ))
    }

@delegate:ResourceContentHash(1_096_086_644)
internal val Res.string.tajMahalArtifactCulture: StringResource by lazy {
      StringResource("string:tajMahalArtifactCulture", "tajMahalArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 99060, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40768, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45648, 39),
      ))
    }

@delegate:ResourceContentHash(-1_400_593_283)
internal val Res.string.tajMahalArtifactGeolocation: StringResource by lazy {
      StringResource("string:tajMahalArtifactGeolocation", "tajMahalArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 99108, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40812, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45688, 43),
      ))
    }

@delegate:ResourceContentHash(-1_777_793_772)
internal val Res.string.tajMahalCallout1: StringResource by lazy {
      StringResource("string:tajMahalCallout1", "tajMahalCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 99160, 420),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 40868, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45732, 192),
      ))
    }

@delegate:ResourceContentHash(648_525_463)
internal val Res.string.tajMahalCallout2: StringResource by lazy {
      StringResource("string:tajMahalCallout2", "tajMahalCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 99581, 380),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41029, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45925, 172),
      ))
    }

@delegate:ResourceContentHash(234_016_722)
internal val Res.string.tajMahalCollectible1Icon: StringResource by lazy {
      StringResource("string:tajMahalCollectible1Icon", "tajMahalCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 99962, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41174, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46098, 44),
      ))
    }

@delegate:ResourceContentHash(-1_500_580_903)
internal val Res.string.tajMahalCollectible1Title: StringResource by lazy {
      StringResource("string:tajMahalCollectible1Title", "tajMahalCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100015, 93),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41215, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46143, 61),
      ))
    }

@delegate:ResourceContentHash(116_452_027)
internal val Res.string.tajMahalCollectible2Icon: StringResource by lazy {
      StringResource("string:tajMahalCollectible2Icon", "tajMahalCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100109, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41269, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46205, 44),
      ))
    }

@delegate:ResourceContentHash(1_948_662_592)
internal val Res.string.tajMahalCollectible2Title: StringResource by lazy {
      StringResource("string:tajMahalCollectible2Title", "tajMahalCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100162, 81),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41310, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46250, 61),
      ))
    }

@delegate:ResourceContentHash(588_971_644)
internal val Res.string.tajMahalCollectible3Icon: StringResource by lazy {
      StringResource("string:tajMahalCollectible3Icon", "tajMahalCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100244, 60),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41376, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46312, 40),
      ))
    }

@delegate:ResourceContentHash(-1_327_512_771)
internal val Res.string.tajMahalCollectible3Title: StringResource by lazy {
      StringResource("string:tajMahalCollectible3Title", "tajMahalCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100305, 113),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41417, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46353, 73),
      ))
    }

@delegate:ResourceContentHash(-1_383_692_418)
internal val Res.string.tajMahalConstructionInfo1: StringResource by lazy {
      StringResource("string:tajMahalConstructionInfo1", "tajMahalConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 100419, 1581),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 41487, 537),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46427, 653),
      ))
    }

@delegate:ResourceContentHash(1_272_527_669)
internal val Res.string.tajMahalConstructionInfo2: StringResource by lazy {
      StringResource("string:tajMahalConstructionInfo2", "tajMahalConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 102001, 1113),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 42025, 437),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47081, 481),
      ))
    }

@delegate:ResourceContentHash(1_025_971_425)
internal val Res.string.tajMahalHistoryInfo1: StringResource by lazy {
      StringResource("string:tajMahalHistoryInfo1", "tajMahalHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 103115, 892),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 42463, 388),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47563, 420),
      ))
    }

@delegate:ResourceContentHash(1_902_760_037)
internal val Res.string.tajMahalHistoryInfo2: StringResource by lazy {
      StringResource("string:tajMahalHistoryInfo2", "tajMahalHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 104008, 712),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 42852, 288),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47984, 336),
      ))
    }

@delegate:ResourceContentHash(-1_494_041_427)
internal val Res.string.tajMahalLocationInfo1: StringResource by lazy {
      StringResource("string:tajMahalLocationInfo1", "tajMahalLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 104721, 581),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43141, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48321, 285),
      ))
    }

@delegate:ResourceContentHash(1_705_742_981)
internal val Res.string.tajMahalLocationInfo2: StringResource by lazy {
      StringResource("string:tajMahalLocationInfo2", "tajMahalLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 105303, 553),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43319, 245),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48607, 285),
      ))
    }

@delegate:ResourceContentHash(87_358_621)
internal val Res.string.tajMahalMapCaption: StringResource by lazy {
      StringResource("string:tajMahalMapCaption", "tajMahalMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 105857, 230),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43565, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48893, 106),
      ))
    }

@delegate:ResourceContentHash(-1_854_727_855)
internal val Res.string.tajMahalPullQuote1Author: StringResource by lazy {
      StringResource("string:tajMahalPullQuote1Author", "tajMahalPullQuote1Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106088, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43656, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49000, 52),
      ))
    }

@delegate:ResourceContentHash(1_708_597_610)
internal val Res.string.tajMahalPullQuote1Bottom: StringResource by lazy {
      StringResource("string:tajMahalPullQuote1Bottom", "tajMahalPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106165, 112),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43717, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49053, 60),
      ))
    }

@delegate:ResourceContentHash(1_603_675_747)
internal val Res.string.tajMahalPullQuote1Top: StringResource by lazy {
      StringResource("string:tajMahalPullQuote1Top", "tajMahalPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106278, 105),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43778, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49114, 57),
      ))
    }

@delegate:ResourceContentHash(-1_923_981_936)
internal val Res.string.tajMahalPullQuote2: StringResource by lazy {
      StringResource("string:tajMahalPullQuote2", "tajMahalPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106481, 286),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43889, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49233, 162),
      ))
    }

@delegate:ResourceContentHash(1_245_115_814)
internal val Res.string.tajMahalPullQuote2Author: StringResource by lazy {
      StringResource("string:tajMahalPullQuote2Author", "tajMahalPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106384, 96),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 43844, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49172, 60),
      ))
    }

@delegate:ResourceContentHash(-480_552_387)
internal val Res.string.tajMahalRegionTitle: StringResource by lazy {
      StringResource("string:tajMahalRegionTitle", "tajMahalRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106768, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44008, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49396, 43),
      ))
    }

@delegate:ResourceContentHash(113_555_385)
internal val Res.string.tajMahalSubTitle: StringResource by lazy {
      StringResource("string:tajMahalSubTitle", "tajMahalSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106832, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44056, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49440, 44),
      ))
    }

@delegate:ResourceContentHash(701_389_861)
internal val Res.string.tajMahalTitle: StringResource by lazy {
      StringResource("string:tajMahalTitle", "tajMahalTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106909, 49),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44097, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49485, 33),
      ))
    }

@delegate:ResourceContentHash(834_727_885)
internal val Res.string.tajMahalVideoCaption: StringResource by lazy {
      StringResource("string:tajMahalVideoCaption", "tajMahalVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 106959, 440),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44131, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49519, 192),
      ))
    }

@delegate:ResourceContentHash(-84_030_607)
internal val Res.string.taj_mahal_title: StringResource by lazy {
      StringResource("string:taj_mahal_title", "taj_mahal_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 107400, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49712, 35),
      ))
    }

@delegate:ResourceContentHash(1_518_561_638)
internal val Res.string.timelineEvent1001ce: StringResource by lazy {
      StringResource("string:timelineEvent1001ce", "timelineEvent1001ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 107456, 255),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44300, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49748, 119),
      ))
    }

@delegate:ResourceContentHash(793_711_425)
internal val Res.string.timelineEvent1077ce: StringResource by lazy {
      StringResource("string:timelineEvent1077ce", "timelineEvent1077ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 107712, 143),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44428, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49868, 91),
      ))
    }

@delegate:ResourceContentHash(-380_551_441)
internal val Res.string.timelineEvent1117ce: StringResource by lazy {
      StringResource("string:timelineEvent1117ce", "timelineEvent1117ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 107856, 155),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44484, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49960, 75),
      ))
    }

@delegate:ResourceContentHash(-911_011_098)
internal val Res.string.timelineEvent1199ce: StringResource by lazy {
      StringResource("string:timelineEvent1199ce", "timelineEvent1199ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 108012, 187),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44536, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50036, 67),
      ))
    }

@delegate:ResourceContentHash(1_323_453_848)
internal val Res.string.timelineEvent1227ce: StringResource by lazy {
      StringResource("string:timelineEvent1227ce", "timelineEvent1227ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 108200, 103),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44604, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50104, 63),
      ))
    }

@delegate:ResourceContentHash(1_754_728_813)
internal val Res.string.timelineEvent1337ce: StringResource by lazy {
      StringResource("string:timelineEvent1337ce", "timelineEvent1337ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 108304, 339),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44668, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50168, 127),
      ))
    }

@delegate:ResourceContentHash(-1_906_389_351)
internal val Res.string.timelineEvent1347ce: StringResource by lazy {
      StringResource("string:timelineEvent1347ce", "timelineEvent1347ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 108644, 347),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44764, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50296, 207),
      ))
    }

@delegate:ResourceContentHash(2_097_054_886)
internal val Res.string.timelineEvent1428ce: StringResource by lazy {
      StringResource("string:timelineEvent1428ce", "timelineEvent1428ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 108992, 167),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44896, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50504, 75),
      ))
    }

@delegate:ResourceContentHash(1_439_068_986)
internal val Res.string.timelineEvent1439ce: StringResource by lazy {
      StringResource("string:timelineEvent1439ce", "timelineEvent1439ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 109160, 223),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 44976, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50580, 87),
      ))
    }

@delegate:ResourceContentHash(82_540_239)
internal val Res.string.timelineEvent1492ce: StringResource by lazy {
      StringResource("string:timelineEvent1492ce", "timelineEvent1492ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 109384, 179),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45060, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50668, 83),
      ))
    }

@delegate:ResourceContentHash(-1_541_400_248)
internal val Res.string.timelineEvent1760ce: StringResource by lazy {
      StringResource("string:timelineEvent1760ce", "timelineEvent1760ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 109564, 135),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45148, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50752, 71),
      ))
    }

@delegate:ResourceContentHash(-1_764_651_319)
internal val Res.string.timelineEvent1763ce: StringResource by lazy {
      StringResource("string:timelineEvent1763ce", "timelineEvent1763ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 109700, 111),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45204, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50824, 75),
      ))
    }

@delegate:ResourceContentHash(1_166_094_420)
internal val Res.string.timelineEvent1783ce: StringResource by lazy {
      StringResource("string:timelineEvent1783ce", "timelineEvent1783ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 109812, 219),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45264, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50900, 111),
      ))
    }

@delegate:ResourceContentHash(-383_436_269)
internal val Res.string.timelineEvent1789ce: StringResource by lazy {
      StringResource("string:timelineEvent1789ce", "timelineEvent1789ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110032, 139),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45352, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51012, 67),
      ))
    }

@delegate:ResourceContentHash(-594_794_319)
internal val Res.string.timelineEvent1800bce: StringResource by lazy {
      StringResource("string:timelineEvent1800bce", "timelineEvent1800bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110172, 100),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45404, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51080, 64),
      ))
    }

@delegate:ResourceContentHash(1_766_661_882)
internal val Res.string.timelineEvent1914ce: StringResource by lazy {
      StringResource("string:timelineEvent1914ce", "timelineEvent1914ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110273, 91),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45461, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51145, 43),
      ))
    }

@delegate:ResourceContentHash(-1_308_263_662)
internal val Res.string.timelineEvent1929ce: StringResource by lazy {
      StringResource("string:timelineEvent1929ce", "timelineEvent1929ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110365, 199),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45517, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51189, 107),
      ))
    }

@delegate:ResourceContentHash(-238_709_876)
internal val Res.string.timelineEvent1939ce: StringResource by lazy {
      StringResource("string:timelineEvent1939ce", "timelineEvent1939ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110565, 99),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45593, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51297, 43),
      ))
    }

@delegate:ResourceContentHash(755_910_118)
internal val Res.string.timelineEvent1957ce: StringResource by lazy {
      StringResource("string:timelineEvent1957ce", "timelineEvent1957ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110665, 175),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45649, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51341, 79),
      ))
    }

@delegate:ResourceContentHash(-570_381_948)
internal val Res.string.timelineEvent1969ce: StringResource by lazy {
      StringResource("string:timelineEvent1969ce", "timelineEvent1969ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110841, 139),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45721, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51421, 75),
      ))
    }

@delegate:ResourceContentHash(-1_547_718_203)
internal val Res.string.timelineEvent2000bce: StringResource by lazy {
      StringResource("string:timelineEvent2000bce", "timelineEvent2000bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 110981, 100),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45789, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51497, 64),
      ))
    }

@delegate:ResourceContentHash(-77_753_442)
internal val Res.string.timelineEvent200bce: StringResource by lazy {
      StringResource("string:timelineEvent200bce", "timelineEvent200bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111082, 139),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45842, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51562, 75),
      ))
    }

@delegate:ResourceContentHash(235_277_534)
internal val Res.string.timelineEvent2200bce: StringResource by lazy {
      StringResource("string:timelineEvent2200bce", "timelineEvent2200bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111222, 136),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45902, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51638, 60),
      ))
    }

@delegate:ResourceContentHash(1_763_093_375)
internal val Res.string.timelineEvent2500bce: StringResource by lazy {
      StringResource("string:timelineEvent2500bce", "timelineEvent2500bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111359, 96),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 45951, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51699, 60),
      ))
    }

@delegate:ResourceContentHash(-1_476_590_960)
internal val Res.string.timelineEvent2560bce: StringResource by lazy {
      StringResource("string:timelineEvent2560bce", "timelineEvent2560bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111456, 168),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46000, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51760, 92),
      ))
    }

@delegate:ResourceContentHash(-1_349_722_087)
internal val Res.string.timelineEvent2600bce: StringResource by lazy {
      StringResource("string:timelineEvent2600bce", "timelineEvent2600bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111625, 180),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46097, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51853, 100),
      ))
    }

@delegate:ResourceContentHash(704_210_424)
internal val Res.string.timelineEvent2700bce: StringResource by lazy {
      StringResource("string:timelineEvent2700bce", "timelineEvent2700bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111806, 168),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46174, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51954, 72),
      ))
    }

@delegate:ResourceContentHash(1_360_979_504)
internal val Res.string.timelineEvent2900bce: StringResource by lazy {
      StringResource("string:timelineEvent2900bce", "timelineEvent2900bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 111975, 180),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46231, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52027, 80),
      ))
    }

@delegate:ResourceContentHash(-2_066_904_604)
internal val Res.string.timelineEvent322bce: StringResource by lazy {
      StringResource("string:timelineEvent322bce", "timelineEvent322bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 112156, 183),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46304, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52108, 99),
      ))
    }

@delegate:ResourceContentHash(-1_782_234_424)
internal val Res.string.timelineEvent427bce: StringResource by lazy {
      StringResource("string:timelineEvent427bce", "timelineEvent427bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 112340, 135),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46424, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52208, 71),
      ))
    }

@delegate:ResourceContentHash(1_189_240_344)
internal val Res.string.timelineEvent43ce: StringResource by lazy {
      StringResource("string:timelineEvent43ce", "timelineEvent43ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 112476, 225),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46496, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52280, 101),
      ))
    }

@delegate:ResourceContentHash(-1_970_953_232)
internal val Res.string.timelineEvent447bce: StringResource by lazy {
      StringResource("string:timelineEvent447bce", "timelineEvent447bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 112702, 163),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46558, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52382, 87),
      ))
    }

@delegate:ResourceContentHash(1_336_074_325)
internal val Res.string.timelineEvent44bce: StringResource by lazy {
      StringResource("string:timelineEvent44bce", "timelineEvent44bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 112866, 198),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46634, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52470, 98),
      ))
    }

@delegate:ResourceContentHash(1_385_287_457)
internal val Res.string.timelineEvent455ce: StringResource by lazy {
      StringResource("string:timelineEvent455ce", "timelineEvent455ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113065, 102),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46705, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52569, 58),
      ))
    }

@delegate:ResourceContentHash(-560_240_488)
internal val Res.string.timelineEvent4bce: StringResource by lazy {
      StringResource("string:timelineEvent4bce", "timelineEvent4bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113168, 85),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46760, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52628, 53),
      ))
    }

@delegate:ResourceContentHash(488_385_916)
internal val Res.string.timelineEvent500ce: StringResource by lazy {
      StringResource("string:timelineEvent500ce", "timelineEvent500ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113254, 138),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46814, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52682, 78),
      ))
    }

@delegate:ResourceContentHash(-142_970_787)
internal val Res.string.timelineEvent632ce: StringResource by lazy {
      StringResource("string:timelineEvent632ce", "timelineEvent632ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113393, 166),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46901, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52761, 82),
      ))
    }

@delegate:ResourceContentHash(-1_729_378_018)
internal val Res.string.timelineEvent753bce: StringResource by lazy {
      StringResource("string:timelineEvent753bce", "timelineEvent753bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113560, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 46992, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52844, 51),
      ))
    }

@delegate:ResourceContentHash(-985_659_005)
internal val Res.string.timelineEvent776bce: StringResource by lazy {
      StringResource("string:timelineEvent776bce", "timelineEvent776bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113640, 159),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47040, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52896, 75),
      ))
    }

@delegate:ResourceContentHash(-919_413_962)
internal val Res.string.timelineEvent793ce: StringResource by lazy {
      StringResource("string:timelineEvent793ce", "timelineEvent793ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113800, 190),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47108, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52972, 70),
      ))
    }

@delegate:ResourceContentHash(442_264_465)
internal val Res.string.timelineEvent79ce: StringResource by lazy {
      StringResource("string:timelineEvent79ce", "timelineEvent79ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 113991, 185),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47179, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53043, 89),
      ))
    }

@delegate:ResourceContentHash(1_875_712_330)
internal val Res.string.timelineEvent800ce: StringResource by lazy {
      StringResource("string:timelineEvent800ce", "timelineEvent800ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114177, 118),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47249, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53133, 66),
      ))
    }

@delegate:ResourceContentHash(-518_086_587)
internal val Res.string.timelineEvent890bce: StringResource by lazy {
      StringResource("string:timelineEvent890bce", "timelineEvent890bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114296, 123),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47312, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53200, 79),
      ))
    }

@delegate:ResourceContentHash(-890_619_704)
internal val Res.string.timelineLabelConstruction: StringResource by lazy {
      StringResource("string:timelineLabelConstruction", "timelineLabelConstruction", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114420, 125),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47404, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53280, 73),
      ))
    }

@delegate:ResourceContentHash(-1_086_872_433)
internal val Res.string.timelineSemanticDate: StringResource by lazy {
      StringResource("string:timelineSemanticDate", "timelineSemanticDate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114546, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47470, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53354, 44),
      ))
    }

@delegate:ResourceContentHash(581_581_962)
internal val Res.string.timelineTitleGlobalTimeline: StringResource by lazy {
      StringResource("string:timelineTitleGlobalTimeline", "timelineTitleGlobalTimeline", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114599, 99),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47519, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53399, 55),
      ))
    }

@delegate:ResourceContentHash(742_876_281)
internal val Res.string.titleLabelDate: StringResource by lazy {
      StringResource("string:titleLabelDate", "titleLabelDate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114699, 46),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47579, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53455, 38),
      ))
    }

@delegate:ResourceContentHash(-134_008_047)
internal val Res.string.wallpaperCheckboxShowTitle: StringResource by lazy {
      StringResource("string:wallpaperCheckboxShowTitle", "wallpaperCheckboxShowTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114746, 86),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47618, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53494, 50),
      ))
    }

@delegate:ResourceContentHash(-998_340_876)
internal val Res.string.wallpaperModalSave: StringResource by lazy {
      StringResource("string:wallpaperModalSave", "wallpaperModalSave", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114912, 226),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47724, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53600, 78),
      ))
    }

@delegate:ResourceContentHash(915_346_146)
internal val Res.string.wallpaperModalSaveComplete: StringResource by lazy {
      StringResource("string:wallpaperModalSaveComplete", "wallpaperModalSaveComplete", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 114833, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47669, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53545, 54),
      ))
    }

@delegate:ResourceContentHash(2_037_072_151)
internal val Res.string.wallpaperModalSaving: StringResource by lazy {
      StringResource("string:wallpaperModalSaving", "wallpaperModalSaving", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 115139, 152),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 47803, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53679, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("pyramidsGizaPullQuote1Top", Res.string.pyramidsGizaPullQuote1Top)
  map.put("pyramidsGizaPullQuote2", Res.string.pyramidsGizaPullQuote2)
  map.put("pyramidsGizaPullQuote2Author", Res.string.pyramidsGizaPullQuote2Author)
  map.put("pyramidsGizaRegionTitle", Res.string.pyramidsGizaRegionTitle)
  map.put("pyramidsGizaSubTitle", Res.string.pyramidsGizaSubTitle)
  map.put("pyramidsGizaTitle", Res.string.pyramidsGizaTitle)
  map.put("pyramidsGizaVideoCaption", Res.string.pyramidsGizaVideoCaption)
  map.put("resultsPopupEnglishContent", Res.string.resultsPopupEnglishContent)
  map.put("resultsSemanticDismiss", Res.string.resultsSemanticDismiss)
  map.put("scrollingContentSemanticOpen", Res.string.scrollingContentSemanticOpen)
  map.put("scrollingContentSemanticYoutube", Res.string.scrollingContentSemanticYoutube)
  map.put("searchInputHintSearch", Res.string.searchInputHintSearch)
  map.put("searchInputSemanticClear", Res.string.searchInputSemanticClear)
  map.put("searchInputTitleSuggestions", Res.string.searchInputTitleSuggestions)
  map.put("semanticsNext", Res.string.semanticsNext)
  map.put("semanticsPrevious", Res.string.semanticsPrevious)
  map.put("tajMahal1631ce", Res.string.tajMahal1631ce)
  map.put("tajMahal1647ce", Res.string.tajMahal1647ce)
  map.put("tajMahal1658ce", Res.string.tajMahal1658ce)
  map.put("tajMahal1901ce", Res.string.tajMahal1901ce)
  map.put("tajMahal1984ce", Res.string.tajMahal1984ce)
  map.put("tajMahal1998ce", Res.string.tajMahal1998ce)
  map.put("tajMahalArtifactCulture", Res.string.tajMahalArtifactCulture)
  map.put("tajMahalArtifactGeolocation", Res.string.tajMahalArtifactGeolocation)
  map.put("tajMahalCallout1", Res.string.tajMahalCallout1)
  map.put("tajMahalCallout2", Res.string.tajMahalCallout2)
  map.put("tajMahalCollectible1Icon", Res.string.tajMahalCollectible1Icon)
  map.put("tajMahalCollectible1Title", Res.string.tajMahalCollectible1Title)
  map.put("tajMahalCollectible2Icon", Res.string.tajMahalCollectible2Icon)
  map.put("tajMahalCollectible2Title", Res.string.tajMahalCollectible2Title)
  map.put("tajMahalCollectible3Icon", Res.string.tajMahalCollectible3Icon)
  map.put("tajMahalCollectible3Title", Res.string.tajMahalCollectible3Title)
  map.put("tajMahalConstructionInfo1", Res.string.tajMahalConstructionInfo1)
  map.put("tajMahalConstructionInfo2", Res.string.tajMahalConstructionInfo2)
  map.put("tajMahalHistoryInfo1", Res.string.tajMahalHistoryInfo1)
  map.put("tajMahalHistoryInfo2", Res.string.tajMahalHistoryInfo2)
  map.put("tajMahalLocationInfo1", Res.string.tajMahalLocationInfo1)
  map.put("tajMahalLocationInfo2", Res.string.tajMahalLocationInfo2)
  map.put("tajMahalMapCaption", Res.string.tajMahalMapCaption)
  map.put("tajMahalPullQuote1Author", Res.string.tajMahalPullQuote1Author)
  map.put("tajMahalPullQuote1Bottom", Res.string.tajMahalPullQuote1Bottom)
  map.put("tajMahalPullQuote1Top", Res.string.tajMahalPullQuote1Top)
  map.put("tajMahalPullQuote2", Res.string.tajMahalPullQuote2)
  map.put("tajMahalPullQuote2Author", Res.string.tajMahalPullQuote2Author)
  map.put("tajMahalRegionTitle", Res.string.tajMahalRegionTitle)
  map.put("tajMahalSubTitle", Res.string.tajMahalSubTitle)
  map.put("tajMahalTitle", Res.string.tajMahalTitle)
  map.put("tajMahalVideoCaption", Res.string.tajMahalVideoCaption)
  map.put("taj_mahal_title", Res.string.taj_mahal_title)
  map.put("timelineEvent1001ce", Res.string.timelineEvent1001ce)
  map.put("timelineEvent1077ce", Res.string.timelineEvent1077ce)
  map.put("timelineEvent1117ce", Res.string.timelineEvent1117ce)
  map.put("timelineEvent1199ce", Res.string.timelineEvent1199ce)
  map.put("timelineEvent1227ce", Res.string.timelineEvent1227ce)
  map.put("timelineEvent1337ce", Res.string.timelineEvent1337ce)
  map.put("timelineEvent1347ce", Res.string.timelineEvent1347ce)
  map.put("timelineEvent1428ce", Res.string.timelineEvent1428ce)
  map.put("timelineEvent1439ce", Res.string.timelineEvent1439ce)
  map.put("timelineEvent1492ce", Res.string.timelineEvent1492ce)
  map.put("timelineEvent1760ce", Res.string.timelineEvent1760ce)
  map.put("timelineEvent1763ce", Res.string.timelineEvent1763ce)
  map.put("timelineEvent1783ce", Res.string.timelineEvent1783ce)
  map.put("timelineEvent1789ce", Res.string.timelineEvent1789ce)
  map.put("timelineEvent1800bce", Res.string.timelineEvent1800bce)
  map.put("timelineEvent1914ce", Res.string.timelineEvent1914ce)
  map.put("timelineEvent1929ce", Res.string.timelineEvent1929ce)
  map.put("timelineEvent1939ce", Res.string.timelineEvent1939ce)
  map.put("timelineEvent1957ce", Res.string.timelineEvent1957ce)
  map.put("timelineEvent1969ce", Res.string.timelineEvent1969ce)
  map.put("timelineEvent2000bce", Res.string.timelineEvent2000bce)
  map.put("timelineEvent200bce", Res.string.timelineEvent200bce)
  map.put("timelineEvent2200bce", Res.string.timelineEvent2200bce)
  map.put("timelineEvent2500bce", Res.string.timelineEvent2500bce)
  map.put("timelineEvent2560bce", Res.string.timelineEvent2560bce)
  map.put("timelineEvent2600bce", Res.string.timelineEvent2600bce)
  map.put("timelineEvent2700bce", Res.string.timelineEvent2700bce)
  map.put("timelineEvent2900bce", Res.string.timelineEvent2900bce)
  map.put("timelineEvent322bce", Res.string.timelineEvent322bce)
  map.put("timelineEvent427bce", Res.string.timelineEvent427bce)
  map.put("timelineEvent43ce", Res.string.timelineEvent43ce)
  map.put("timelineEvent447bce", Res.string.timelineEvent447bce)
  map.put("timelineEvent44bce", Res.string.timelineEvent44bce)
  map.put("timelineEvent455ce", Res.string.timelineEvent455ce)
  map.put("timelineEvent4bce", Res.string.timelineEvent4bce)
  map.put("timelineEvent500ce", Res.string.timelineEvent500ce)
  map.put("timelineEvent632ce", Res.string.timelineEvent632ce)
  map.put("timelineEvent753bce", Res.string.timelineEvent753bce)
  map.put("timelineEvent776bce", Res.string.timelineEvent776bce)
  map.put("timelineEvent793ce", Res.string.timelineEvent793ce)
  map.put("timelineEvent79ce", Res.string.timelineEvent79ce)
  map.put("timelineEvent800ce", Res.string.timelineEvent800ce)
  map.put("timelineEvent890bce", Res.string.timelineEvent890bce)
  map.put("timelineLabelConstruction", Res.string.timelineLabelConstruction)
  map.put("timelineSemanticDate", Res.string.timelineSemanticDate)
  map.put("timelineTitleGlobalTimeline", Res.string.timelineTitleGlobalTimeline)
  map.put("titleLabelDate", Res.string.titleLabelDate)
  map.put("wallpaperCheckboxShowTitle", Res.string.wallpaperCheckboxShowTitle)
  map.put("wallpaperModalSave", Res.string.wallpaperModalSave)
  map.put("wallpaperModalSaveComplete", Res.string.wallpaperModalSaveComplete)
  map.put("wallpaperModalSaving", Res.string.wallpaperModalSaving)
}
